import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KYMW1321Component } from './kymw1321.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetNvalPeriodCSVService } from './api-services/get-nval-period-csv.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';

/**
 * プロモ商品企画点検リスト画面　モジュール設定クラス
 *
 * @export KYMW1321Module
 * @class KYMW1321Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1321Component,
  ],
  providers: [
    GetNvalPeriodCSVService,
    FileDownloadConfirmService,
  ],
})

export class KYMW1321Module { }
